// src/components/settings/shared/About.tsx

import React, { useState, useEffect } from 'react';
import { CircularProgress } from '@mui/material';
import { versionAPI } from '../../../services/api';
import {
  SettingsBlock,
  SettingsCard,
  SectionLabel,
  Section,
  RetentionGrid,
  RetentionStat,
  StatLabel,
  StatValue,
} from './SystemSettingsElements';

// Minimal version display for now: App / Frontend / Backend, side by side.
// A fuller "About" surface (What's New, Help Center, Report an issue - see
// Chrome's Help menu for the shape we're aiming at) is a good candidate for
// a future item once Tier 5 (Playwright) wraps, but is intentionally out of
// scope here to avoid speculative complexity.
const About: React.FC = () => {
  const [backendVersion, setBackendVersion] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const fetchVersion = async () => {
      try {
        const result = await versionAPI.getVersion();
        if (!cancelled) {
          setBackendVersion(result.backend);
        }
      } catch {
        if (!cancelled) {
          setBackendVersion(null);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchVersion();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <SettingsBlock sx={{ mt: 0 }}>
      <SettingsCard elevation={0}>
        <Section>
          <SectionLabel>About</SectionLabel>
          <RetentionGrid>
            <RetentionStat>
              <StatLabel>App Version</StatLabel>
              <StatValue>{__APP_VERSION__}</StatValue>
            </RetentionStat>
            <RetentionStat>
              <StatLabel>Frontend Version</StatLabel>
              <StatValue>{__FRONTEND_VERSION__}</StatValue>
            </RetentionStat>
            <RetentionStat>
              <StatLabel>Backend Version</StatLabel>
              <StatValue>
                {loading ? (
                  <CircularProgress size={14} />
                ) : (
                  (backendVersion ?? 'Unavailable')
                )}
              </StatValue>
            </RetentionStat>
          </RetentionGrid>
        </Section>
      </SettingsCard>
    </SettingsBlock>
  );
};

export default About;
